import {GetAccess,Login,JaccountLogin,GetUserInfo,GetPhoneCode,PostPhoneCode} from '@/api/app'
import Cookies from 'js-cookie'

const app = {
  state: {
    nowPath: Cookies.get('nowPath') || '/'
  },
  mutations: {
    SET_NOWPATH: (state,nowPath) => {
      Cookies.set('nowPath', nowPath,{ expires: 180 })
    }
  },
  actions: {
    commitNowPath({commit},nowPath){
      commit('SET_NOWPATH',nowPath)
    },
    getAccess({commit},){
      return new Promise((resolve, reject) => {
        GetAccess().then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    login({commit},code){
      return new Promise((resolve, reject) => {
        Login(code).then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    jaccountLogin({commit},params){
      return new Promise((resolve, reject) => {
        JaccountLogin(params).then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getUserInfo({commit}){
      return new Promise((resolve, reject) => {
        GetUserInfo().then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getPhoneCode({commit},phone){
      return new Promise((resolve, reject) => {
        GetPhoneCode(phone).then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    postPhoneCode({commit},params){
      return new Promise((resolve, reject) => {
        PostPhoneCode(params).then(response => {
          const data = response.data
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js


// WEBPACK FOOTER //
// ./src/store/modules/app.js